module.exports = __webpack_public_path__ + "static/media/ball_3_2.903d50ca.mp3";